import type { Trade } from '../types';

export type Outcome = 'win' | 'loss' | 'be';

export function classifyPnl(pnl: number, beRange: number): Outcome {
  if (beRange > 0 && Math.abs(pnl) <= beRange) return 'be';
  if (pnl > 0) return 'win';
  if (pnl < 0) return 'loss';
  return 'be';
}

export function classifyTrade(t: Trade, beRange: number): Outcome {
  return classifyPnl(t.pnl, beRange);
}

export function isWin(t: Trade, beRange: number) {
  return classifyPnl(t.pnl, beRange) === 'win';
}
export function isLoss(t: Trade, beRange: number) {
  return classifyPnl(t.pnl, beRange) === 'loss';
}
export function isBE(t: Trade, beRange: number) {
  return classifyPnl(t.pnl, beRange) === 'be';
}

export function splitByOutcome(trades: Trade[], beRange: number) {
  const wins: Trade[] = [];
  const losses: Trade[] = [];
  const bes: Trade[] = [];
  for (const t of trades) {
    const o = classifyPnl(t.pnl, beRange);
    if (o === 'win') wins.push(t);
    else if (o === 'loss') losses.push(t);
    else bes.push(t);
  }
  return { wins, losses, bes };
}

export function calcWinRate(trades: Trade[], beRange: number): number {
  const { wins, losses } = splitByOutcome(trades, beRange);
  const denom = wins.length + losses.length;
  return denom ? (wins.length / denom) * 100 : 0;
}

export function countOutcomes(trades: Trade[], beRange: number) {
  const { wins, losses, bes } = splitByOutcome(trades, beRange);
  return { wins: wins.length, losses: losses.length, bes: bes.length };
}
